<template>
  <svg width="24" height="25" viewBox="0 0 24 25" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M9 18.4346L13.4665 13.0748C13.7216 12.7686 13.8491 12.6156 13.8491 12.4346C13.8491 12.2535 13.7216 12.1005 13.4665 11.7944L9 6.43457" :stroke="color" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
  </svg>
</template>

<script>
export default {
  props: {
    color: {
      type: String,
      default: '#6171E4',
    },
  },
};
</script>
